function isValidNumber(inputValue, allowDecimal = false) {
  // Regular expression to allow only numbers, and optionally a decimal point
  const regex = allowDecimal ? /^[0-9]+(\.[0-9]{1,2})?$/ : /^[0-9]+$/;

  // Test the input value against the regex and return true if it matches
  return regex.test(inputValue);
}

export function checkStartForm(state) {
  // isShown: true, // Used to detern if the form is displayed
  // audienceRatio: 0.5,
  // isGiveMeTheBest: false,
  // thresholdSelection: null,
  // isWholeOrLocation: true,
  // targetSpend: null,
  // targetQuanity: null,
  // minProspects: null,
  // channels: [],
  // activeChannel: null,

  // User has not selected a channel
  if(state.activeChannel === null) {
    return "Please select a channel"
  } 

  // User has not selected a threshold
  if(state.thresholdSelection === null) {
    return "Please choose a threshold selection"
  }

  // User had not enterd in a target spend
  if(state.thresholdSelection === 'spend' && (state.targetSpend === null || state.targetSpend === "")) {
    return "Please fill in your threshold spend"
  }

  // User had entered invalid target spend
  if(state.thresholdSelection === 'spend' && !isValidNumber(state.targetSpend, true)) {
    return "Please enter a valid number for your threshold spend"
  }

  // User had not enterd in a target quanity
  if(state.thresholdSelection === 'quantity' && (state.targetQuanity === null || state.targetQuanity === "")) {
    return "Please fill in your threshold quantity"
  }

  // User had entered invalud target quanity
  if(state.thresholdSelection === 'quantity' && !isValidNumber(state.targetQuanity, true)) {
    return "Please enter a valid number threshold quantity"
  }

  return ""
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/util/validation/checkStartForm.js